import { constantRoutes } from '@/router'
import Layout from '@/components/header'
import store from '../index'

const state = {
    activeNav:[],//当前激活菜单导航
    activeMenuId: null, // 【新增】当前激活的具体菜单项 ID
    menuList:[],
}

const mutations = {
    SET_MENULIST: (state, menuList) => {//设置菜单列表
        state.menuList = menuList
    },
    SET_ACTIVE_NAV: (state, activeNav) => {//设置当前激活菜单
        state.activeNav = activeNav
    },
    // 【新增】设置当前激活的具体菜单项 ID
    SET_ACTIVE_MENU_ID: (state, activeMenuId) => {
        state.activeMenuId = activeMenuId
    },
}
const actions = {
    set_active_route({ commit }, activeRoute) {
        const menuId = findMenuIdByPath(state.menuList, activeRoute)
        commit('SET_ACTIVE_MENU_ID', menuId)
        const parentIds = findParentIds(state.menuList, menuId)
        commit('SET_ACTIVE_NAV', parentIds)
    },

    generateRoutes({ commit }, routes) {
        return new Promise(resolve => {
            const accessedRoutes = filterAsyncRoutes(routes )
            commit('SET_MENULIST', routes)
            const flatRoutes = splitRoutes(accessedRoutes)
            resolve(flatRoutes)
        })
    }
}
function findMenuIdByPath(list, targetPath) {//查询路由对应的ID
    for (let item of list) {
        // 匹配路径 (注意：可能需要处理末尾斜杠或参数动态路由的情况，这里做简单严格匹配)
        // 如果 path 可能包含查询参数，建议使用 item.path === targetPath.split('?')[0]
        if (item.path === targetPath) {
            return item.id
        }
        // 如果有子节点，递归查找
        if (item.children && item.children.length > 0) {
            const foundId = findMenuIdByPath(item.children, targetPath)
            if (foundId !== null) {
                return foundId
            }
        }
    }
    return null
}
function findParentIds(list, targetId, path = []) {
    for (let item of list) {
        // 如果找到目标节点，返回当前路径（即所有父级ID）
        if (item.id === targetId) {
            return [...path]
        }
        // 如果有子节点，递归查找
        if (item.children && item.children.length > 0) {
            // 将当前节点ID加入路径
            const newPath = [...path, item.id]
            const result = findParentIds(item.children, targetId, newPath)
            
            // 如果在子树中找到了，返回结果
            if (result.length > 0 || (item.children.some(child => child.id === targetId))) {
                 // 注意：上面的递归返回值处理需要更严谨
                 // 如果子递归返回了非空数组，说明找到了
                 if (result !== null && result !== undefined) {
                     return result
                 }
            }
        }
    }
    // 未找到
    return []
}
function splitRoutes(accessRoutes){
    const flatRoutes = []
    accessRoutes.forEach(item=>{
        flatRoutes.push({
            id: item.id,
            pid:item.pid,
            path: item.path,
            name: item.name,
            component:resetComponent(item.component,item.name),
            hidden: item.hidden,
            isOpen: item.isOpen,
            meta: item.meta,
        })
    })
    return flatRoutes
}
function resetComponent(component, customName) {
  if (component === "Layout" || component === "layout") { // 兼容大小写
    return Layout
  } else if (!component) {
    return null
  } else {
    // 去除可能的 .vue 后缀，防止路径重复
    const cleanComponent = component.replace(/\.vue$/, '')
    
    return (resolve) => {
      // 使用 webpack 的动态导入
      require([`@/views/${cleanComponent}.vue`], (module) => {
        if (module && module.default) {
           resolve(module.default)
        } else {
           console.error(`组件加载失败: @/views/${cleanComponent}.vue`, module)
           resolve(null) // 或者解析到一个错误页面组件
        }
      }, (error) => {
         console.error(`组件路径错误: @/views/${cleanComponent}`, error)
         resolve(null)
      })
    }
  }
}
export function filterAsyncRoutes(routes) {
    let res = []
    routes.forEach(route => {
        const tmp = { ...route }
        if (tmp.children && tmp.children.length > 0) {// 如果有子路由，递归处理
            // 递归获取子路由并拼接到结果中
            // 注意：这种方式会把所有层级都变成同级兄弟节点
            const children = filterAsyncRoutes(tmp.children, tmp.fullPath)
            res = res.concat(children)
            // 如果不需要保留父级容器节点，可以注释掉下面这行
            res.push(tmp) 
        } else {
            // 叶子节点，直接加入
            delete tmp.children // 清理空子项
            res.push(tmp)
        }
    })
    return res
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}